export default "__VITE_ASSET__BRV2zMOF__"